<template>
    <div>
        <div  class="modal_design">
            <b-modal title="নতুন বিল" no-close-on-backdrop hide-footer size="md" v-model="largeModal" @ok="largeModal = false">
                <form   @submit.prevent="billCreate()">
                    <div class="form-group">
                        <label for="exampleInputEmail1">Create date</label>
                        <input v-model="data.date" name="create_date" data-vv-as="'Create date'" v-validate="'required'" type="date" class="form-control" id="exampleInputEmail1">
                        <p v-show="errors.has('create_date')"  style="color:red">* {{ errors.first('create_date') }}</p>
                    </div>
                    <div class="form-group">
                        <label for="exampleInputPassword1">Last payment date</label>
                        <input v-model="data.last_date" name="last_date"  data-vv-as="'Last date'" v-validate="'required'" type="date" class="form-control" id="exampleInputPassword1">
                        <p v-show="errors.has('last_date')"  style="color:red">* {{ errors.first('last_date') }}</p>
                    </div>
                    <button type="submit" class="btn btn-primary">Submit</button>
                    </form>
            </b-modal>
        </div>
        <Loader v-if="loading"></Loader>
    </div>
</template>

<script>
    import Loader from '../common/Loader'
    import axios from 'axios'
    export default {
        name: "Bill Create",
        components:{
            Loader
        },
        data(){
            return{
                loading:false,
                largeModal:false,
                data:{
                    date:'',
                    last_date:'',
                    invoice_type:'',
                    skip:0
                },
                date:null
            }
        },

        methods:{
            billCreate()
            {
                if(this.$route.name =='Water billing'){
                    this.data.invoice_type = 'water-billing'
                }
                else if(this.$route.name =='Water Ofc billing'){
                    this.data.invoice_type = 'water-ofc-billing'
                }
                else if(this.$route.name =='Market billing'){
                    this.data.invoice_type = 'market-billing'
                }

                // this.largeModal=false
                this.$validator.validateAll().then( result =>{
                    if(result){
                        var input_date = new Date(this.data.date)
                        var input_month = input_date.getMonth()+1;
                        var input_year = input_date.getFullYear();

                        var last_month = parseInt(this.date.month)
                        var last_year = parseInt(this.date.year)

                        //alert(input_year)

                        if(input_year > last_year || input_month > last_month){
                            this.loading = true
                            this.createBillStart()
                        }
                        else{
                            alert('Bill already exist');
                        }

                    }

                })
            },
            openModal(date){
                //console.log(date)
                this.date = date;
                this.largeModal = true;
            },
            async createBillStart(){
                await this.createBill1()
                await this.createBill2()
                await this.createBill3()
                await this.createBill4()
                await this.createBill5()
                await this.createBill6()
                await this.createBill7()
                await this.createBill8()
                await this.createBill9()
                await this.createBill10()
                await this.createBill11()
                await this.createBill12()
                await this.createBill13()
                await this.createBill14()
                await this.createBill15()
                await this.createBill16()
                await this.createBill17()
                await this.createBill18()
                await this.createBill19()
                await this.createBill20()

            },
            async createBill1(){
                this.data.skip = 0;
                await axios.post('/api/bill-generate',this.data).then(response=>{
                })
                .catch(error=>{
                });
            },
            async createBill2(){
                this.data.skip = 1000;
                await axios.post('/api/bill-generate',this.data).then(response=>{
                })
                .catch(error=>{
                });
            },
            async createBill3(){
                this.data.skip = 2000;
                await axios.post('/api/bill-generate',this.data).then(response=>{
                })
                .catch(error=>{
                });
            },
            async createBill4(){
                this.data.skip = 3000;
                await axios.post('/api/bill-generate',this.data).then(response=>{
                })
                .catch(error=>{
                });
            },
            async createBill4(){
                this.data.skip = 3000;
                await axios.post('/api/bill-generate',this.data).then(response=>{
                })
                .catch(error=>{
                });
            },
            async createBill5(){
                this.data.skip = 4000;
                await axios.post('/api/bill-generate',this.data).then(response=>{
                })
                .catch(error=>{
                });
            },
            async createBill6(){
                this.data.skip = 5000;
                await axios.post('/api/bill-generate',this.data).then(response=>{
                })
                .catch(error=>{
                });
            },
            async createBill7(){
                this.data.skip = 6000;
                await axios.post('/api/bill-generate',this.data).then(response=>{
                })
                .catch(error=>{
                });
            },
            async createBill8(){
                this.data.skip = 7000;
                await axios.post('/api/bill-generate',this.data).then(response=>{
                })
                .catch(error=>{
                });
            },
            async createBill9(){
                this.data.skip = 8000;
                await axios.post('/api/bill-generate',this.data).then(response=>{
                })
                .catch(error=>{
                });
            },
            async createBill10(){
                this.data.skip = 9000;
                await axios.post('/api/bill-generate',this.data).then(response=>{
                })
                .catch(error=>{
                });
            },
            async createBill11(){
                this.data.skip = 10000;
                await axios.post('/api/bill-generate',this.data).then(response=>{
                })
                .catch(error=>{
                });
            },
            async createBill12(){
                this.data.skip = 11000;
                await axios.post('/api/bill-generate',this.data).then(response=>{
                })
                .catch(error=>{
                });
            },
            async createBill13(){
                this.data.skip = 12000;
                await axios.post('/api/bill-generate',this.data).then(response=>{
                })
                .catch(error=>{
                });
            },
            async createBill14(){
                this.data.skip = 13000;
                await axios.post('/api/bill-generate',this.data).then(response=>{
                })
                .catch(error=>{
                });
            },
            async createBill15(){
                this.data.skip = 14000;
                await axios.post('/api/bill-generate',this.data).then(response=>{
                })
                .catch(error=>{
                });
            },
            async createBill16(){
                this.data.skip = 15000;
                await axios.post('/api/bill-generate',this.data).then(response=>{
                })
                .catch(error=>{
                });
            },
            async createBill17(){
                this.data.skip = 16000;
                await axios.post('/api/bill-generate',this.data).then(response=>{
                })
                .catch(error=>{
                });
            },
            async createBill18(){
                this.data.skip = 17000;
                await axios.post('/api/bill-generate',this.data).then(response=>{
                })
                .catch(error=>{
                });
            },
            async createBill19(){
                this.data.skip = 18000;
                await axios.post('/api/bill-generate',this.data).then(response=>{
                })
                .catch(error=>{
                });
            },
            async createBill20(){
                this.data.skip = 19000;
                await axios.post('/api/bill-generate',this.data).then(response=>{
                    this.loading = false
                    this.$parent.getBills();
                    this.largeModal = false
                    this.$swal(
                        'Created',
                        'Bill has been created.',
                        'success'
                    )
                })
                .catch(error=>{
                });
            }
        }
    }
</script>

<style scoped>
    .modal_design{
        width: 300px;
        _height: 100px;
    }
</style>